var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cafe_navi", attrs: { id: "cafe_navi_default" } },
    [
      _vm.isAdmin
        ? _c("span", { staticClass: "tab_btns tab_btns_type2" }, [
            _c(
              "button",
              {
                staticClass: "link_btns #end_btn",
                class: { disabled: !_vm.progressing },
                attrs: { id: "btn_apply_stop" },
                on: { click: _vm.stopApply }
              },
              [_vm._v("참여종료")]
            )
          ])
        : _c("span", { staticClass: "tab_btns tab_btns_type2" }, [
            _c(
              "a",
              {
                staticClass: "link_btns #apply_btn",
                class: { disabled: !_vm.progressing },
                attrs: { href: _vm.newArticleUrl, id: "btn_apply" },
                on: { click: _vm.checkPeriod }
              },
              [
                _c("span", { staticClass: "apply_txt" }, [_vm._v("참여하기")]),
                _c("span", { staticClass: "ico_cafe write_cafe_btn" })
              ]
            )
          ]),
      _vm._v(" "),
      _c("h2", [
        _c(
          "a",
          {
            staticClass: "link_pre",
            attrs: { href: _vm.backUrl, role: "button" }
          },
          [
            _c("strong", { staticClass: "tit_pre" }, [
              _c("span", { staticClass: "ico_cafe ico_arr" }),
              _vm._v(_vm._s(_vm.boardName))
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }